<template>
  <div
    class="owal landing page"
  >
    <owal-panel
      title="Welcome"
      :show-top-banner="false"
    >
      <div
        style="text-align: center; padding: 0; margin: 0;"
      >
        <img
          src="../../assets/img/nav/Owal Dark@2x.png"
          class="owal-logo"
          style="margin-bottom: 1.5rem; margin-top: 1.5rem; transform: scale(1.2);"
        >
      </div>
      <div
        class="owal-login-window__button-area"
      >
        <p
          v-if="message"
          class="owal message"
        >
          {{ message }}
        </p>
        <login-button
          provider="google"
        />
        <login-button
          provider="microsoft"
        />
        <login-button
          provider="auth0"
        />
      </div>
      <div
        class="owal-login-window__footer"
      >
        Support: <a
          href="mailto://support@owal.io"
          title="Contact Support"
        >support@owal.io</a><br>
        Request a demo or an account at <a
          href="http://owal.io/contact.html"
          title="https://owal.io"
        >https://owal.io</a>
      </div>
    </owal-panel>
  </div>
</template>

<script>
import OwalPanel from '@/libraries/owal-ui/panels/OwalPanel'
import LoginButton from '@/components/shared/LoginButton'
export default {
  name: 'Template',
  components: { OwalPanel, LoginButton },
  computed: {
    message () {
      const message = this.$route.query.message
      return message
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.owal.landing.page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100%;
}

/** The three arrows is a Vue thing, allowing us to style child components while being scoped. */
.owal.landing.page >>> .owal.panel.active.window {
  width: 22.8571428571rem;
}

.owal-logo {
  height: 40px;
  width: 160px;
}

.owal.message {
  display: flex;
  text-align: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0.2857142857rem;
  margin: 0.2857142857rem;
  padding: 0.5714285714rem;
  background-color: #f4f4f4;
}

.owal-login-window__footer {
  display: block;
  width: 100%;
  margin: 1rem 0 0 0;
  padding: 0;
  text-align: center;
  transform: scale(0.95);
  color: #324057;
  flex-shrink: 0;
}

.owal-login-window__footer a {
  color: #8492a6;
  transition: color 200ms ease;
}

.owal-login-window__footer a:hover {
  color: #c0ccda;
}

.owal-login-window__button-area {
  width: 100%;
  padding: 0;
  margin: 0;
}
</style>
